import { render } from "./OrdersList.vue?vue&type=template&id=194d8dec&scoped=true"
import script from "./OrdersList.vue?vue&type=script&lang=js"
export * from "./OrdersList.vue?vue&type=script&lang=js"

import "./OrdersList.vue?vue&type=style&index=0&id=194d8dec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194d8dec"]])

export default __exports__